import {
  FieldTypes,
  IFieldInstance,
} from "../../../types/fieldInstance.interface";
import { FormGroupContainer } from "./incidentForm.style";
import { spanTwoFields } from "../../../utils/helpers/constants";
import FormFieldGroup from "../formFieldGenerator/FormFieldGroup";

interface ISectionFormFields {
  formGroup: IFieldInstance[];
  getError: any;
}

const SectionFormFields = ({ formGroup, getError }: ISectionFormFields) => {
  const hasSpanTwoFields = formGroup.some((field) =>
    spanTwoFields.includes(field.fieldType as FieldTypes)
  );

  const branchedFormGroupParents = formGroup.filter(
    (field) =>
      (field.fieldType as FieldTypes) ===
      FieldTypes.BranchedMultiSelectasCheckBoxes
  );
  let _formGroup = [...formGroup];
  // get root form group
  const processedFields: string[] = [];
  type IBranchedFormGroupObj = {
    [condition: string]: IFieldInstance[];
  };
  const structuredBranchedFormGroups: {
    [id: string]: IBranchedFormGroupObj;
  } = {};

  const branchedFormGroupObj: IBranchedFormGroupObj = {};

  function groupField(field: IFieldInstance, condition: string) {
    if (!branchedFormGroupObj[condition]) {
      branchedFormGroupObj[condition] = [];
    }
    branchedFormGroupObj[condition].push(field);
    processedFields.push(field.id);

    if (field.childFieldIds && field.childFieldIds.length > 0) {
      field.childFieldIds.forEach((childId) => {
        const childField = formGroup.find((field) => field.id === childId);
        childField && groupField(childField, condition);
      });
    }
  }

  if (branchedFormGroupParents.length) {
    const branchedFormGroupParentIds = branchedFormGroupParents.map(
      (branchedFormGroup) => branchedFormGroup.id
    );
    branchedFormGroupParentIds.forEach((rootFieldId) => {
      const relatedFields = formGroup.filter(
        (field) => field.parentFieldId === rootFieldId
      );

      relatedFields.forEach((field) =>
        groupField(
          field,
          JSON.stringify((field.condition as string).toLowerCase())
        )
      );
      structuredBranchedFormGroups[rootFieldId] = { ...branchedFormGroupObj };
      _formGroup = _formGroup.filter(
        (field) => !processedFields.includes(field.id)
      );
    });
  }
  return (
    <FormGroupContainer hasSpanTwoFields={hasSpanTwoFields}>
      <FormFieldGroup
        formGroup={_formGroup}
        getError={getError}
        childFormGroups={structuredBranchedFormGroups}
      />
    </FormGroupContainer>
  );
};

export default SectionFormFields;
